import { render, staticRenderFns } from "./StaffPortalServiceRedirect.vue?vue&type=template&id=7998a64a&"
import script from "./StaffPortalServiceRedirect.vue?vue&type=script&lang=js&"
export * from "./StaffPortalServiceRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports